import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ErrorCustom from './components/common/ErrorBoundary/ErrorCustom';
import Footer from './components/common/Footer/Footer';
import Header from './components/common/Header/Header';
import CustomSpinner from './components/common/Spinner';
import SiteContentProvider from './components/hoc/SiteContentProvider';
import OfferNavigation, { NavigationSteps } from './components/OfferDetails/OfferNavigation';
import ConuntdownTimer from './components/OfferEligibility/CountdownTimer';
import CurrentProspectSummary from './components/OfferSearch/CurrentProspectSummary';
import OfferAvailability from './features/offerAvailability/OfferAvailabilityContainer';
import OfferConfirmationContainer from './features/offerConfirmation/OfferConfirmationContainer';
import OfferContactInformationContainer from './features/offerContactInfo/OfferContactInformationContainer';
import OfferDestination from './features/offerDestination/OfferDestinationContainer';
import OfferDetails from './features/offerDetails/OfferDetailsContainer';
import OfferEligibility from './features/offerEligibility/OfferEligibilityContainer';
import OfferSearch from './features/offerSearch/OfferSearchContainer';
import OfferSummaryContainer from './features/offerSummary/OfferSummaryContainer';
import SecurityTokenManager from './features/sessionManager/SecurityTokenManagerContainer';
import SessionManager from './features/sessionManager/SessionManagerContainer';
import { RootState } from './redux/rootReducer';
import {
  OFFER_CONFIRMATION_PATH,
  OFFER_CONTACT_INFO_PATH,
  OFFER_DATES_PATH,
  OFFER_DESTINATION_PATH,
  OFFER_ELIGIBILITY_PATH,
  OFFER_REVIEW_PATH,
  // eslint-disable-next-line prettier/prettier
  VIEW_OFFERS_PATH,
} from './util/strings';
// import { PaymentContextPayload, PaymentContextResponse } from './features/offerConfirmation/types';
// import { UNABLE_TO_CONTACT_PROVIDER, createError } from './util';
// import apiClientCyberSource from './apiClient';
interface IProps {
  lang: string;
}
const TIMER_DURATION_IN_SECONDS = 900;
// const PAYMENT_CONTEXT_ENDPOINT = `${process.env.REACT_APP_PAYMENT_CONTEXT_ENDPOINT}`;
// const PAYMENT_MERCHANT_GROUP_ID = `${process.env.REACT_APP_MERCHANT_GROUPID}`;
// const LOCATION_ORIGIN = window.location.origin;
const Main = (props: IProps): JSX.Element => {
  const timerDuration = process.env.REACT_APP_TIMER_DURATION_IN_SECONDS
    ? parseInt(process.env.REACT_APP_TIMER_DURATION_IN_SECONDS, 10)
    : TIMER_DURATION_IN_SECONDS;
  const currentNavigationStep: NavigationSteps = useSelector(
    (state: RootState) => state.offerDetails.currentNavigationStep,
  );
  const openDateSelector: boolean | undefined = useSelector(
    (state: RootState) => state.availabilityDates.openDateSelector,
  );
  const renderTimer =
    !openDateSelector && currentNavigationStep !== NavigationSteps.OFFER_CONFIRMATION ? (
      <div className="row">
        <ConuntdownTimer countdownDuration={timerDuration}></ConuntdownTimer>
      </div>
    ) : (
      <></>
    );
  const [securityTokenManager, setSecurityTokenManager] = useState(<></>);
  const [idleTimemanager, setIdleTimemanager] = useState(<></>);
  useEffect(() => {
    setSecurityTokenManager(<SecurityTokenManager></SecurityTokenManager>);
    setIdleTimemanager(<SessionManager></SessionManager>);
  }, []);
  // useEffect(() => {
  //   fetchCyberSourceData(PAYMENT_MERCHANT_GROUP_ID, LOCATION_ORIGIN);
  // }, []);
  const offers = useSelector((state: RootState) => state.offerDetails);
  const hasMultipleOffers: boolean = offers && offers.primaryOffer && offers.primaryOffer.length > 0 ? true : false;
  // function parseJwt(token) {
  //   var base64Url = token.split('.')[1];
  //   var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  //   var jsonPayload = decodeURIComponent(
  //     window
  //       .atob(base64)
  //       .split('')
  //       .map(function (c) {
  //         return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  //       })
  //       .join(''),
  //   );

  //   return JSON.parse(jsonPayload);
  // }
  // const fetchCyberSourceData = async (merchanrGroupId: string, origin: string): Promise<PaymentContextResponse> => {
  //   const requestUrl = `${PAYMENT_CONTEXT_ENDPOINT}?merchantGroupId=${merchanrGroupId}`;
  //   const requestPayload: any = {
  //     targetOrigins: [origin],
  //   };
  //   const returnValue: PaymentContextResponse = {
  //     hasError: false,
  //   };
  //   try {
  //     const response = await apiClientCyberSource.postCyberSource<PaymentContextPayload, PaymentContextResponse>(
  //       requestUrl,
  //       requestPayload,
  //     );
  //     returnValue.status = response.status;
  //     returnValue.contextTokens = response.contextTokens;
  //     const cyberSourceToken = returnValue.contextTokens && returnValue.contextTokens[0].key;
  //     const clientLibraryJwt = cyberSourceToken && parseJwt(cyberSourceToken).ctx[0].data.clientLibrary;
  //     const clientLibraryIntegrityJwt =
  //       cyberSourceToken && parseJwt(cyberSourceToken).ctx[0].data.clientLibraryIntegrity;
  //     // create script tag
  //     const script = document.createElement('script');
  //     script.src = clientLibraryJwt;
  //     script.type = 'text/javascript';
  //     script.async = true;
  //     script.integrity = clientLibraryIntegrityJwt;
  //     script.crossOrigin = 'anonymous';
  //     // run setup code after script has loaded successfully
  //     script.onload = function () {
  //       // SETUP
  //     };
  //     // insert to document
  //     document.head.appendChild(script);
  //     if (response.status !== 'success') {
  //       response.hasError = true;
  //     }
  //   } catch (e) {
  //     returnValue.hasError = true;
  //     returnValue.error = createError(UNABLE_TO_CONTACT_PROVIDER);
  //   }

  //   return returnValue;
  // };
  return (
    <SiteContentProvider>
      <Header></Header>
      <>{securityTokenManager}</>
      <>{idleTimemanager}</>
      <CustomSpinner></CustomSpinner>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={OfferSearch} />
          <Route exact path="/CA" component={OfferSearch} />
          <Route exact path="/FA" component={OfferSearch} />
          <Route
            path={[
              OFFER_DESTINATION_PATH,
              VIEW_OFFERS_PATH,
              OFFER_DATES_PATH,
              OFFER_ELIGIBILITY_PATH,
              OFFER_CONTACT_INFO_PATH,
              OFFER_REVIEW_PATH,
              OFFER_CONFIRMATION_PATH,
            ]}
          >
            <CurrentProspectSummary></CurrentProspectSummary>
            <OfferNavigation
              currentStep={currentNavigationStep}
              hasMultipleOffers={hasMultipleOffers}
            ></OfferNavigation>
            <Route exact path={OFFER_DESTINATION_PATH} render={(props) => <OfferDestination {...props} />} />
            <Route exact path={VIEW_OFFERS_PATH} render={(props) => <OfferDetails {...props} />} />
            <Route exact path={OFFER_DATES_PATH} render={(props) => <OfferAvailability {...props} />} />
            <Route exact path={OFFER_CONFIRMATION_PATH} render={(props) => <OfferConfirmationContainer />} />
            <Route path={[OFFER_ELIGIBILITY_PATH, OFFER_CONTACT_INFO_PATH, OFFER_REVIEW_PATH, OFFER_CONFIRMATION_PATH]}>
              {renderTimer}
              <Route
                exact
                path={OFFER_ELIGIBILITY_PATH}
                render={(props) => <OfferEligibility {...props} stepIndex={3} />}
              />
              <Route exact path={OFFER_CONTACT_INFO_PATH} render={(props) => <OfferContactInformationContainer />} />
              <Route exact path={OFFER_REVIEW_PATH} render={(props) => <OfferSummaryContainer />} />
            </Route>
          </Route>
          <Route path="/*" render={() => <ErrorCustom />}></Route>
        </Switch>
      </BrowserRouter>
      <div className="container">
        <Footer></Footer>
      </div>
    </SiteContentProvider>
  );
};

export default React.memo(Main);
